import { Box, Skeleton, SkeletonText } from "@chakra-ui/react"

const CardLoader = ({ width = "100%", height = "170px" }) => {
  return (
    <Box
      width={width}
      maxW={width}
      flex="1 1 250px" // allow flexible width but minimum 250px
    >
      <Skeleton height={height} width="100%" borderRadius="md" />
      <SkeletonText noOfLines={1} mt={2} maxW="70%" borderRadius="md" />
    </Box>
  )
}

export default CardLoader